import { render } from "./PcHeader.vue?vue&type=template&id=ea8e5e4a&scoped=true"
import script from "./PcHeader.vue?vue&type=script&lang=js"
export * from "./PcHeader.vue?vue&type=script&lang=js"

import "./PcHeader.vue?vue&type=style&index=0&id=ea8e5e4a&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9acfb15ce118456a03f39fb117bb0076/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea8e5e4a"]])

export default __exports__